import request from "@/utils/request";

// 问卷列表
export function surveyList(data) {
  return request({
    url: "/survey/findEnableSurvey",
    method: "post",
    data,
    openLoading: false,
  });
}

// 问卷详情
export function surveyDetalis(data) {
  return request({
    url: "/survey/findById",
    method: "post",
    data,
  });
}

// 提交问卷
export function submitSurvey(data) {
  return request({
    url: "/survey/submitAnswers",
    method: "post",
    data,
  });
}